import Subpage from '../Subpage';

export default function Privacy() {
  return (
    <div className="flex flex-col w-full items-center justify-center">
      <Subpage heading="Privacy" contents={require('../../resources/privacy.json')} />
    </div>
  )
}
